import React from "react";
import { connect } from "react-redux";

import { withStyles } from "@material-ui/core/styles";
import { Dialog, DialogTitle as MuiDialogTitle, IconButton, Typography, List } from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";

import useStyles from "./styles";
import CallConnected from "./Images/CallConnected";

//store
import * as actions from "../../../../store/actions/actionIndex";

const styles = (theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: "absolute",
		insetInlineEnd: "0px",
		top: "0px",
		color: theme.palette.grey[500],
	},
});

const DialogTitle = withStyles(styles)((props) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});

function SimpleDialog(props) {
	const classes = useStyles();
	const [open, setOpen] = React.useState(false);

	React.useEffect(() => {
		if (props.transferInfo) {
			setOpen(false);
		}
	}, [props.transferInfo]);

	const handleClose = () => {
		setOpen(false);
		props.onUnsetTransfer(props.agentId);
	};

	return (
		<div className={classes.DialogBox}>
			<Dialog onClose={handleClose} style={{ height: "350px", width: "auto" }} aria-labelledby="simple-dialog-title" open={open}>
				<DialogTitle onClose={handleClose} className={classes.DialogTitleMain}>
					<List>
						<div className={classes.CallConnectedIcon}>
							<CallConnected />
						</div>
						<Typography className={classes.StatusWords}>Transfer Successful to {props.transferInfo}</Typography>
					</List>
				</DialogTitle>
			</Dialog>
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		agentId: state.agentData.agentId,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onUnsetTransfer: (agentId) => dispatch(actions.unsetTransfer(agentId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SimpleDialog);
